import { render, staticRenderFns } from "./price-checker.vue?vue&type=template&id=085270cd&scoped=true&"
import script from "./price-checker.vue?vue&type=script&lang=js&"
export * from "./price-checker.vue?vue&type=script&lang=js&"
import style0 from "./price-checker.vue?vue&type=style&index=0&id=085270cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085270cd",
  null
  
)

export default component.exports